import { render, staticRenderFns } from "./zSelect.vue?vue&type=template&id=505e0f9c&scoped=true"
import script from "./zSelect.vue?vue&type=script&lang=js"
export * from "./zSelect.vue?vue&type=script&lang=js"
import style0 from "./zSelect.vue?vue&type=style&index=0&id=505e0f9c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505e0f9c",
  null
  
)

export default component.exports